import React from 'react';

import PrintTemplateGroupDialog from './PrintTemplateGroupDialog';

const PrintPdfDialog = ({
  open,
  onClose,
  deviceIds,
  printTemplateGroups,
  defaultFilename = 'devices.pdf'
}) => (
  <PrintTemplateGroupDialog
    open={open}
    onClose={onClose}
    printTemplateGroups={printTemplateGroups}
    endpoint="printing/pdf/"
    buildBody={(templateGroup) => ({
      device_ids: deviceIds,
      template_group_id: templateGroup
    })}
    defaultFilename={defaultFilename}
    errorMessage="Failed to generate PDF"
  />
);

export default PrintPdfDialog;
